

import React, { useState, useEffect } from 'react';
import styles from './styles/ScenarioModal.module.css';
import axios from 'axios';

const ScenarioModal = ({
    isOpen,
    onClose,
    selectedScenarios,
    onScenarioSelect,
    onSubmit,
}) => {
    const [closing, setClosing] = useState(false);
    const [searchTerm, setSearchTerm] = useState(''); 
    const [scenarios, setScenarios] = useState([]);

    useEffect(() => {
        const fetchUserScenarios = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL_LOCAL}/api/scenarios/my`
                );
                setScenarios(response.data);
            } catch (error) {
                console.error('Error fetching user scenarios:', error);
            }
        };

        fetchUserScenarios();
    }, []);

    const triggerClose = () => {
        setClosing(true);
        setTimeout(() => {
            onClose();
            setClosing(false);
        }, 300); 
    };

    if (!isOpen && !closing) return null;

    
    const filteredScenarios = scenarios.filter((scenario) =>
        scenario.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className={`${styles.modalOverlay} ${closing ? styles.fadeOut : styles.fadeIn}`}>
            <div className={styles.modalContent}>
                {/* Modal Header */}
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>Add Scenarios</h2>
                </div>

                {/* Modal Body */}
                <div className={styles.modalBody}>
                    {/* Search Input */}
                    <div className={styles.searchContainer}>
                        <input
                            type="text"
                            placeholder="Search scenarios..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className={styles.searchInput}
                        />
                    </div>

                    {/* Scenarios List */}
                    <ul className={styles.list}>
                        {filteredScenarios.map((scenario) => (
                            <li
                                key={scenario._id}
                                onClick={() => onScenarioSelect(scenario)}
                                className={`${styles.item} ${
                                    selectedScenarios.some((s) => s._id === scenario._id)
                                        ? styles.selectedItem
                                        : ''
                                }`}
                            >
                                {scenario.title}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Modal Footer */}
                <div className={styles.modalFooter}>
                    <div className={styles.buttonContainer}>
                        <button
                            className={`${styles.buttonBase} ${styles.saveButton}`}
                            onClick={onSubmit}
                        >
                            Add Selected Scenarios
                        </button>
                        <button
                            className={`${styles.buttonBase} ${styles.cancelButton}`}
                            onClick={triggerClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ScenarioModal;
